import { SearchOutlined } from '@ant-design/icons';
import { AutoComplete, Col, DatePicker, Form, Input, message, Modal, Row } from 'antd';
import locale from 'antd/es/date-picker/locale/sr_RS';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import 'moment/locale/sr';
import React, { useEffect, useState } from 'react';
import settings from '../../../settings';
import api from '../../../utils/api';

const AddInvoiceModal = ({ children, onOk, ...rest }) => {
  const [visible, setVisible] = useState(false);

  const [form] = Form.useForm();
  const [suppliers, setSuppliers] = useState({});
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (visible) {
      api
        .get(`suppliers`, { params: { group: true, active: true } })
        .then((response) => {
          setSuppliers(response.data.suppliers);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
      api
        .get(`users`)
        .then((response) => {
          setUsers(response.data.users);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [visible]);

  const onFinish = (values) => {
    let key = 'invoiceCreation';
    message.loading({ content: 'Dodavanje prijemnice...', key });
    setLoading(true);
    api
      .post(`invoice/add`, {
        date: values.date.toISOString(),
        supplier: values.supplierid,
        measurer: values.measurerid,
      })
      .then((response) => {
        setUsers(response.data.users);
        message.success({
          content: `Prijemnica broj ${response.data.result.number} uspješno dodana!`,
          key,
          duration: 5,
        });
        setVisible(false);
        form.resetFields();
        onOk();
        setLoading(false);
      })
      .catch((error) => {
        message.error({ content: 'Greška pri dodavanju prijemnice.', key, duration: 5 });
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <>
      <div onClick={() => setVisible(true)}>{children}</div>
      <Modal
        confirmLoading={loading}
        visible={visible}
        title='Nova prijemnica'
        okText='Dodaj prijemnicu'
        cancelText='Otkaži'
        onCancel={() => setVisible(false)}
        onOk={() => {
          form.submit();
        }}>
        <Form layout='vertical' size='middle' requiredMark={false} onFinish={onFinish} form={form}>
          <Form.Item name='supplierid' noStyle>
            <Input type='hidden' />
          </Form.Item>
          <Form.Item name='measurerid' noStyle>
            <Input type='hidden' />
          </Form.Item>
          <Form.Item
            name='supplier'
            label='Ime dobavljača'
            rules={[
              {
                required: true,
                message: 'Odaberite dobavljača!',
              },
            ]}>
            <AutoComplete
              notFoundContent='Ne postoji traženi dobavljač.'
              options={
                suppliers &&
                Object.keys(suppliers).map((letter) => {
                  return {
                    label: letter,
                    options: suppliers[letter].map((supplier) => {
                      return {
                        key: supplier.id,
                        label: (
                          <Row>
                            <Col flex='auto'>
                              <Text strong>{supplier.name}</Text>
                            </Col>
                            <Col flex='20%'>
                              <Text>{supplier.tax ? 'Pravno lice' : 'Fizičko lice'}</Text>
                            </Col>
                          </Row>
                        ),
                        value: supplier.name,
                      };
                    }),
                  };
                })
              }
              onChange={(_, option) =>
                form.setFields([{ name: 'supplierid', value: option && option.key }])
              }
              allowClear
              filterOption={(inputValue, option) =>
                option.value && option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
              }>
              <Input prefix={<SearchOutlined />} placeholder='Pretražite dobavljače' />
            </AutoComplete>
          </Form.Item>
          <Form.Item
            name='measurer'
            label='Mjerio'
            rules={[
              {
                required: true,
                message: 'Odaberite korisnika!',
              },
            ]}>
            <AutoComplete
              notFoundContent='Ne postoji traženi korisnik.'
              options={
                users &&
                users.map((user) => {
                  return {
                    key: user.id,
                    value: user.name,
                  };
                })
              }
              onChange={(_, option) =>
                form.setFields([{ name: 'measurerid', value: option && option.key }])
              }
              allowClear
              filterOption={(inputValue, option) =>
                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
              }>
              <Input prefix={<SearchOutlined />} placeholder='Pretražite radnike' />
            </AutoComplete>
          </Form.Item>
          <Form.Item
            name='date'
            label='Datum'
            initialValue={moment(new Date(), settings.date)}
            rules={[
              {
                required: true,
                message: 'Odaberite datum!',
              },
            ]}>
            <DatePicker style={{ width: '100%' }} locale={locale} format={settings.date} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddInvoiceModal;
